import {BehaviorSubject} from 'rxjs';

const PerformanceStore = {
  pageTimes$: new BehaviorSubject({}),
  registerPageData(data) {
    const current = this.pageTimes$.getValue();
    const { page, ...rest } = data;
    current[page] = current[page] || {};
    current[page] = {
      ...current[page],
      page,
      ...rest,
    }
    this.pageTimes$.next({ ...current });
  },
  startBrowserRender(page) {
    const pageTimes = this.pageTimes$.getValue();
    this.browserPerfStart = {
      page,
      start: performance.now()
    };
  },
  stopBrowserRender() {

  },
  reset() {
    this.pageTimes$.next({});
  }
}

export default PerformanceStore;